<template>
  <el-dialog
    append-to-body
    :title="title"
    :visible.sync="isShow"
    width="600px"
    :close-on-click-modal="false"
  >
    <el-form :model="form" :rules="rules" ref="form" class="text-form">
      <el-form-item label="商品名称:" label-width="90px" prop="productname">
        <el-input
          type="textarea"
          v-model="form.productname"
          :rows="7"
          placeholder="请输入商品名称，最多100个字"
          maxlength="100"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer text-dialog-footer">
      <el-button type="primary" @click="saveProduct('form')">确 定</el-button>
      <el-button @click="resetForm('form')">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>

import netAPI from '@/api';
export default {
  props: ['visible'],
  data() {
    return {
      isRefresh: false,
      isShow: this.visible,
      title: '添加商品',
      form: {
        productname: ''
      },
      rules: {
        productname: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      this.isShow = val;
    },
    isShow(val) {
      if(!val) {
        // 弹窗关闭 触发关闭方法
        this.$emit('close', this.isRefresh)
      }else{
        this.form = {
          productname: ''
        }
      }
    }
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  methods: {
    saveProduct(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.addProName();
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.isShow = false;
    },
    
    addProName() {
      let params = {
        userId: this.userMess.loginId,
        productname: this.form.productname
      };
      netAPI.saveGoodsName(params).then(res => {
        if (res.success) {
          this.$nextTick(() => {
            this.$message({
              message: '添加成功！',
              type: 'success'
            });
          });
          this.isRefresh = true;
          this.isShow = false;
        } else {
          this.$nextTick(() => {
            this.$message({
              message: res.message,
              type: 'error'
            });
          });
        }
      }).catch(() => {
        this.$nextTick(() => {
          this.$message({
            message: '添加失败！',
            type: 'error'
          });
        });
      });
    },
  },
}
</script>